export const getUserFullName = (user) => {
  let fullName = user?.firstName;
  if (user?.lastName) {
    fullName += ' ' + user?.lastName;
  }
  return fullName;
};
